import { QueryObserver } from '@tanstack/query-core';

import { ExcelUploadsListResponse } from '@futrli-sdk/predict';
import { getExcelFilesList } from '../../predict/src/core/api/organisations';
import { queryClient } from '../core/queryClient';

export type ExcelFilesQueryParams = Record<string, string>;

export const excelFilesQueryKey = (
  workspaceId: string,
  organisationId: string,
  queryParams?: ExcelFilesQueryParams
) => ['excelFiles', workspaceId, organisationId, ...(queryParams ? [queryParams] : [])];

export const excelFilesQuery = (
  workspaceId: string,
  organisationId: string,
  queryParams?: ExcelFilesQueryParams
): QueryObserver<ExcelUploadsListResponse> =>
  new QueryObserver<ExcelUploadsListResponse>(queryClient, {
    queryKey: excelFilesQueryKey(workspaceId, organisationId, queryParams),
    queryFn: async () => {
      const res = await getExcelFilesList(workspaceId, organisationId, queryParams ?? {});
      return {
        ...res,
        files: res.files.sort((a, b) => Number(new Date(b.created_at)) - Number(new Date(a.created_at)))
      };
    }
  });
